module.exports = __webpack_public_path__ + "static/banner-promotion-92daa267843bc975c4381c030a3c2e19.png";